import * as React from 'react';

const PaymentChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 4h22v16H1V4zm2 2v3h18V6H3zm18 5H3v7h18v-7zm-11 4H6v-2h4v2zm4 0h-2v-2h2v2z"
            fill="#4B4D63"
        />
    </svg>
);

PaymentChunkySvg.displayName = 'PaymentChunkySvg';
export default PaymentChunkySvg;
